// RollOver Ambassador programme. The previous page carried copy from another
// brand's programme (US residency, PayPal payouts, dollar sales tiers). That
// copy is not RollOver's, so the programme is presented as an interest list
// with structure only; rewards and terms are to be confirmed by the café.
import free from "../../components/Ambassador/Vision/Media/Free.svg";
import cash from "../../components/Ambassador/Vision/Media/Cash.svg";
import learn from "../../components/Ambassador/Vision/Media/Learn.svg";
import insider from "../../components/Ambassador/Vision/Media/Insider.svg";
import signup from "../../components/Ambassador/HowItWorks/Media/SignUp.svg";
import grab from "../../components/Ambassador/HowItWorks/Media/Grab.svg";
import gold from "../../components/Ambassador/Media/gold.png";
import platinum from "../../components/Ambassador/Media/platinum.png";
import diamond from "../../components/Ambassador/Media/diamond.png";
import share1 from "../../components/Ambassador/Media/share1.jpg";
import share2 from "../../components/Ambassador/Media/share2.jpg";

export const ambassadorBenefits = [
  { icon: free, title: "Free treats", text: "Taste new dishes before they reach the menu." },
  { icon: cash, title: "Rewards", text: "Earn rewards when friends order with your word." },
  { icon: learn, title: "Learn and grow", text: "Tips on food content from the RollOver team." },
  { icon: insider, title: "Insider access", text: "Early word on offers, events and launches." },
];

export const ambassadorSteps = [
  { icon: signup, title: "Register your interest", text: "Join the RollOver club with your name and contact." },
  { icon: grab, title: "Share your RollOver moments", text: "Post your visits and tag RollOver Warangal." },
  { icon: cash, title: "Get rewarded", text: "Reward details are confirmed by the café when the programme opens." },
];

export const ambassadorTiers = [
  { name: "Gold", icon: gold },
  { name: "Platinum", icon: platinum },
  { name: "Diamond", icon: diamond },
];

export const ambassadorPhotos = [
  { src: share1, alt: "RollOver food shared on social media" },
  { src: share2, alt: "RollOver food shared on social media" },
];

export const ambassadorFaqs = [
  { q: "What is a RollOver Ambassador?", a: "A regular who loves RollOver food and shares it with friends and followers. Ambassadors help spread the word about new dishes, offers and events." },
  { q: "What do ambassadors get?", a: "The reward structure (treats, discounts or referral rewards) is being finalised by the café. Registered members are told first when it opens." },
  { q: "Who can join?", a: "Anyone in and around Warangal with an active social media account. Register through the RollOver club form and the team will be in touch." },
  { q: "Can I refer a friend?", a: "A referral reward is planned. Until it is confirmed there is no referral code or commission to claim." },
  { q: "Is anything paid out today?", a: "No. This page registers interest only. No commission, payout or discount is promised until the café publishes the programme terms." },
];
